export default "__VITE_ASSET__DFS5LQRd__"